/**
 * Prefix reserved for the synthetic persistence ID of the default account in OWA.
 * Monarch accounts use their native account UUID instead.
 */
export const owaDefaultAccountPersistenceIdPrefix = 'DEFDEFDE-FDEF-DEFD-EFDE-FDEFDEFDEFDE';

export function isOwaDefaultAccountPersistenceId(value: string): boolean {
    return (
        value === owaDefaultAccountPersistenceIdPrefix ||
        value.startsWith(`${owaDefaultAccountPersistenceIdPrefix}-`)
    );
}
